<template>
  <v-layout row style="max-height: 500px">
    <v-flex xs2>
      <NavDrawer @component:update="componentChange" :list="componentList" />
    </v-flex>
    <v-flex xs10>
      <action-table @refresh="refreshHandler" :actionEdit="true" :actionDelete="true" :header="header" :title="headerTitle" :component="activeComponent.component"
        :fields="componentField" :data="componentData" :plant="plant"></action-table>
    </v-flex>
  </v-layout>
</template>

<script>
import NavDrawer from '@/components/common/TreeNavDrawer.vue';
import Header from '@/components/common/ModularComponent/Header.vue';
import ActionTable from '@/components/admin/ActionTable.vue'
import ComponentConfigHelper from '@/helper/component_config/index.js'

import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    section: String,
    plant: Number,
    isActive: Boolean
  },
  components: {
    NavDrawer,
    Header,
    ActionTable,
  },
  data() {
    return {
      activeComponent: '',
      header: [{
          text: 'Name',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Updated By',
          value: 'updated_by',
          sortable: false
        },
        {
          text: 'Updated On',
          value: 'updated_on',
          sortable: false
        },
        {
          text: 'Action',
          value: 'action',
          icon: 'edit',
          action: 'edit',
          sortable: false
        },
        {
          value: 'action',
          icon: 'delete',
          action: 'delete',
          sortable: false
        },
      ],
    }
  },
  mounted() {
    this.activeComponent = this.componentList[1]
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getPlantList']),
    ...mapGetters('admin', ['componentData']),
    headerTitle() {
      return this.activeComponent.name + ' Configuration'
    },
    componentList() {
      const list = [{
        name: 'Back',
        component: 'back',
        icon: 'arrow_back',
        color: '#399785'
      }]

      list.push(...ComponentConfigHelper.components[this.section])

      return list
    },
    componentField() {
      return this.activeComponent ? ComponentConfigHelper.map[this.activeComponent.component].fields : []
    }
  },
  methods: {
    ...mapActions('admin', ['fetchConfig', 'saveConfig', 'updateConfig', 'deleteConfig']),
    componentChange(componentObj) {
      if(componentObj.component === 'back') {
        this.$emit('back')
        return
      }
      this.activeComponent = componentObj
      this.getConfig()
    },
    refreshHandler() {
      this.getConfig()
    },
    getConfig() {
      const identifier = {}
      if (this.section === 'plant') {
        identifier.plant_id = this.plant
      } else if (this.section === 'user') {

      }

      this.fetchConfig({
        component: this.activeComponent.component,
        identifier
      })
    }
  },
  watch: {
    isActive() {
      this.componentChange(this.componentList[1])
    }
  }
}
</script>

<style></style>
